export const marketplaceNotifiedToState = {
  NotNotified: 'empty',
  Notified: 'normal',
  Error: 'error',
  Sent: 'normal',
};

export const amazonShipNotifyFeedStatusMap = {
  success: 'Notified',
  warning: 'Notified',
  error: 'Error',
  partialSuccess: 'Notified',
  cancelled: 'NotNotified',
  sent: 'Sent',
};
